module.exports = __webpack_public_path__ + "img/3-m.cc74ddf9.jpg";